export enum FaultCode {
  Unspecified = 'Unspecified',
  Set = 'Set',
  ApiLevelNoLongerSupported = 'ApiLevelNoLongerSupported',
  Throttling = 'Throttling',
  Duplicate = 'Duplicate',
  WrongPassword = 'WrongPassword',
  NotFound = 'NotFound',
  Unauthorized = 'Unauthorized',
  Forbidden = 'Forbidden',
  IllegalArgument = 'IllegalArgument',
  IllegalState = 'IllegalState',
  Ineligible = 'Ineligible',
  NoData = 'NoData',
  NoExtra = 'NoExtra',
  Depleted = 'Depleted',
  PreconditionFailed = 'PreconditionFailed',
  FileError = 'FileError',
  Expired = 'Expired',
  EndpointSpecific = 'EndpointSpecific',
}

export enum EndpointSpecificFaultCode {
  // VERIFY EMAIL FAULT CODES
  ExistingValidEmail = 'ExistingValidEmail',
  MissingEmail = 'MissingEmail',
  MailerBuilderCreationError = 'MailerBuilderCreationError',
  SendError = 'SendError',

  // TOKEN FAULT CODES
  ExpiredToken = 'ExpiredToken',
}
